import axios from "axios";
import { Buffer } from "buffer";

export function formatDate(dateString) {
  const date = new Date(dateString);

  // Get parts of the date
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const day = date.getDate();
  const daySuffix = (day) => {
    if (day % 10 === 1 && day !== 11) return "st";
    if (day % 10 === 2 && day !== 12) return "nd";
    if (day % 10 === 3 && day !== 13) return "rd";
    return "th";
  };

  const formattedDate = `${day}${daySuffix(day)} ${
    months[date.getMonth()]
  } ${date.getFullYear()}, ${days[date.getDay()]}`;
  return formattedDate;
}

export function convertDateToRegulariseDate(dateString) {
  const [year, month, day] = dateString.split("-");
  return `${day}-${month}-${year}`;
}

export const getCurrentTime = () => {
  const currentTime = new Date();

  const hours = currentTime.getHours().toString().padStart(2, "0");
  const minutes = currentTime.getMinutes().toString().padStart(2, "0");

  return `${hours}:${minutes}`;
};

export const makeEncodedRequest = async (
  url,
  method,
  data = null,
  config = {}
) => {
  try {
    const encodedData =
      data && process.env.REACT_APP_IS_ENCODED === "true"
        ? Buffer.from(JSON.stringify(data)).toString("base64")
        : data;

    const response = await axios({
      url,
      method,
      data: encodedData,
      ...config,
    });

    if (process.env.REACT_APP_IS_ENCODED === "true" && response?.data) {
      try {
        const decodedData = JSON.parse(
          Buffer.from(response.data, "base64").toString("utf8")
        );
        return decodedData;
      } catch (err) {
        console.error("Error decoding Base64 response:", err);
        throw err;
      }
    }

    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const extractErrorMessage = (error) => {
  console.log("Exception", error?.response?.data, typeof error?.response?.data);
  const errorResponse = error?.response?.data?.exception?.error;
  return (
    errorResponse?.description ||
    errorResponse?.message ||
    "An unknown error occurred"
  );
};
